import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import {
  getHomeIndustries,
  getIndustryCommonCopy,
  getLocalizedValue,
} from '../data/industries';
import IndustryIcon from './IndustryIcon';

const IndustriesPreview = () => {
  const { currentLang, isRTL } = useLanguage();
  const copy = getIndustryCommonCopy(currentLang);
  const industries = getHomeIndustries().map((industry) =>
    getLocalizedValue(industry, currentLang)
  );

  return (
    <section
      id="industries"
      className="relative overflow-hidden border-y border-white/[0.07] bg-[#050706] py-20 md:py-28"
      style={{ direction: isRTL ? 'rtl' : 'ltr' }}
    >
      <div className="hero-grid absolute inset-0 opacity-20 pointer-events-none" />
      <div className="relative mx-auto max-w-[1400px] px-5 md:px-[7.6923%]">
        <div className="mb-10 flex flex-col gap-5 md:mb-12 md:flex-row md:items-end md:justify-between">
          <div className="max-w-3xl">
            <p className="mb-3 text-sm font-semibold uppercase text-[#00FFD1]">
              {copy.indexEyebrow}
            </p>
            <h2 className="text-3xl font-semibold leading-tight text-white md:text-5xl">
              {copy.indexTitle}
            </h2>
            <p className="mt-4 text-base leading-7 text-white/58 md:text-lg">
              {copy.indexSubtitle}
            </p>
          </div>
          <Link
            to="/industries"
            className="btn-glass-secondary w-full text-base sm:w-auto"
          >
            {copy.exploreAll}
            <ArrowRight className={`h-5 w-5 ${isRTL ? 'rotate-180' : ''}`} />
          </Link>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
          {industries.map((industry) => (
            <Link
              key={industry.id}
              to={industry.route}
              className="group min-h-[245px] rounded-2xl border border-white/[0.08] bg-white/[0.025] p-6 text-left backdrop-blur-xl transition-all duration-300 hover:-translate-y-1 hover:border-[#00FFD1]/30 hover:bg-[#00FFD1]/[0.035]"
              style={{ textAlign: isRTL ? 'right' : 'left' }}
            >
              <span className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl border border-[#00FFD1]/25 bg-[#00FFD1]/10 text-[#00FFD1]">
                <IndustryIcon icon={industry.icon} />
              </span>
              <h3 className="text-xl font-semibold leading-snug text-white">
                {industry.card.title}
              </h3>
              <p className="mt-3 min-h-[72px] text-sm leading-6 text-white/54">
                {industry.card.summary}
              </p>
              <div className="mt-5 flex items-center justify-between gap-4 border-t border-white/[0.08] pt-4">
                <span className="text-xs font-semibold uppercase text-white/42">
                  {industry.card.signal}
                </span>
                <ArrowRight
                  className={`h-5 w-5 flex-none text-[#00FFD1] transition-transform duration-300 ${
                    isRTL
                      ? 'rotate-180 group-hover:-translate-x-1'
                      : 'group-hover:translate-x-1'
                  }`}
                />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesPreview;
